/* eslint-disable no-multi-spaces */
import homeSchoolImage  from '../../assets/images/materials/home-school.webp';
import newsImage        from '../../assets/images/materials/news.webp';
import parentsImage     from '../../assets/images/materials/parents.webp';
import lifestyleImage   from '../../assets/images/materials/lifestyle.webp';
import lifehackImage    from '../../assets/images/materials/lifehack.webp';
import achievementImage from '../../assets/images/materials/achievement.webp';
import egeImage         from '../../assets/images/materials/ege.webp';
import psychologyImage  from '../../assets/images/materials/psychology.webp';
import skillsImage      from '../../assets/images/materials/skills.webp';
import professionsImage from '../../assets/images/materials/professions.webp';
import webinarsImage    from '../../assets/images/materials/webinars.webp';

export const getCategoryImageUrl = (category) => {
  switch (category?.name?.toLowerCase()) {
    case 'новости':        return newsImage;
    case 'родителям':      return parentsImage;
    case 'лайфстайл':      return lifestyleImage;
    case 'домашняя школа': return homeSchoolImage;
    case 'лайфхаки':       return lifehackImage;
    case 'успеваемость':   return achievementImage;
    case 'егэ и огэ':      return egeImage;
    case 'психология':     return psychologyImage;
    case 'навыки':         return skillsImage;
    case 'профессии':      return professionsImage;
    case 'вебинары':       return webinarsImage;
    default:               return homeSchoolImage;
  }
};

export const WIDGET_TYPE = {
  ARTICLES: 1,
  BANNER: 2,
  BUTTONS: 3,
};

export const BLOCK_TYPES = {
  IMAGE: 0,
  TEXT: 1,
  AUDIO: 2,
  VIDEO: 3,
  HTML: 4,
  FILE: 5,
  WIDGET: 6,
  BANNER: 7,
};

export const months = [
  'Январь', 'Февраль', 'Март',
  'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь',
  'Октябрь', 'Ноябрь', 'Декабрь',
];

export default {
  getCategoryImageUrl,
  WIDGET_TYPE,
  BLOCK_TYPES,
  months,
};
